import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {FaUser} from 'react-icons/fa';

export const JogadorDetalhe = () => {
    const {id} = useParams();
    const [dados, setDados] = useState(null);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        const carregar = async () => {
            try {
                setLoading(true);
                const response = await fetch(`/api/Jogadores/${id}/Detalhes`);
                if (!response.ok) {
                    throw new Error('Erro ao carregar jogador');
                }
                const data = await response.json();
                setDados(data);
            } catch (e) {
                console.error(e);
                setErro('Não foi possível carregar os dados do jogador.');
            } finally {
                setLoading(false);
            }
        };

        carregar();
    }, [id]);

    if (loading) return <p>Carregando jogador...</p>;
    if (erro) return <p className="text-danger">{erro}</p>;
    if (!dados) return <p>Jogador não encontrado.</p>;

    return (
        <div className="container py-3">
            <div className="row mb-3">
                <div className="col-md-4 mb-3">
                    <div className="card shadow-sm">
                        <div className="card-body text-center">
                            <div
                                className="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center mb-3"
                                style={{width: '120px', height: '120px', fontSize: '48px'}}
                            >
                                {
                                    (dados.fotoUrl ? <img src={dados.fotoUrl}/> : <FaUser/>)
                                }
                            </div>
                            <h3 className="fw-bold mb-1">{dados.nome}</h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-8 mb-3">
                    <div className="card shadow-sm h-100">
                        <div className="card-body">
                            <h5 className="card-title mb-3">Pontos por dia</h5>
                            {(!dados.pontosPorDia || dados.pontosPorDia.length === 0) && (
                                <p className="text-muted mb-0">
                                    Nenhuma pontuação registrada ainda para este jogador.
                                </p>
                            )}

                            {dados.pontosPorDia.map((pontoDoDia, idx) => (
                                <>
                                    <div className="d-flex justify-content-end fw-bold">
                                        <div className="badge bg-primary">
                                            {new Date(pontoDoDia.data).toLocaleDateString('pt-BR')}
                                        </div>
                                    </div>
                                    <div className="list-group list-group-flush" style={{margin: '0 -1rem'}}>
                                        {pontoDoDia.pontuacoes.map(pontuacao => (
                                            <div
                                                key={`${pontoDoDia.data}-${idx}`}
                                                className="list-group-item d-flex justify-content-between"
                                            >
                                                <strong className={pontuacao.pontos > 0 ? 'text-success' : 'text-danger'}>
                                                    {pontuacao.pontos}
                                                </strong>
                                                <span>
                                                    {pontuacao.tipoDePontuacao}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};